<template>
  <section>
    <div class="container has-text-centered">
      <h1 class="is-size-1 has-text-weight-bold">Enter code</h1>
      <div key="textfield">
        <input
          v-model="code"
          class="input is-large"
          type="text"
          autofocus
          placeholder="TYPE CODE HERE"
          @focus="inputTouched = true"
          @blur="inputTouched = false"
        />
      </div>
      <div>
        <button :disabled="!code && !inputTouched" class="button is-success is-large" @click="submit">Submit</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      code: null,
      inputTouched: false
    }
  },
  methods: {
    submit () {
      const code = this.code.toUpperCase()
      this.$router.push(`/create/${code}`)
    }
  }

}
</script>

<style scoped lang="stylus">

.container
  @media (min-width: 768px)
    width: 40%

button, input
  width: 90%
  transition: all 1s ease
  margin: 1rem
  text-align: center
input
  text-transform: uppercase

</style>
